import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-page-context-guard',
  standalone: true,
  template: `
    @if (blocked) {
      <div class="page-context-guard">
        <ng-content />
      </div>
    }
  `,
  styles: [`
    .page-context-guard {
      display: block;
      width: 100%;
    }
  `],
})
export class PageContextGuardComponent {
  @Input() public blocked = false;
}
